/* @ngInject */
const formatAccount = (
  utils
) => {
  const self = {}

  self.user = (_user) => {
    const user = utils.copy(_user)

    user.creationDate = utils.date.timestampToString(user.creationDate)

    return user
  }

  return self
}
export default formatAccount



// WEBPACK FOOTER //
// ./public/javascript/sygem/account/services/format.service.js